import moment from "moment";
// Type-only usage; TypeScript elides this at emit
import { GiftcardObject } from "@/views/customer-dashboard/types/index";

/** A card inside this window is flagged so it does not quietly lapse */
export const EXPIRES_SOON_DAYS = 30;

export type GiftcardStatus = "active" | "expires-soon" | "used" | "expired";

export const GIFTCARD_STATUSES: GiftcardStatus[] = [
  "active",
  "expires-soon",
  "used",
  "expired"
];

/**
 * Single source of truth for a card's state, so the badge on the card and the
 * filter above the list can never disagree.
 */
export const getGiftcardStatus = (
  giftcard: GiftcardObject,
  now: number = moment().unix()
): GiftcardStatus => {
  if (giftcard.valid_until && now > giftcard.valid_until) return "expired";
  if (!(giftcard.balance > 0)) return "used";

  const secondsLeft = giftcard.valid_until - now;
  if (giftcard.valid_until && secondsLeft <= EXPIRES_SOON_DAYS * 86400)
    return "expires-soon";

  return "active";
};

/** Colour of the StatusTag each state gets */
export const getGiftcardStatusTagType = (status: GiftcardStatus): string => {
  switch (status) {
    case "active":
      return "green";
    case "expires-soon":
      return "yellow";
    case "expired":
      return "red";
    // A spent card is not a failure, so it stays neutral
    default:
      return "gray";
  }
};
